<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button type="primary" icon="plus" @click="handleAddModal">添加考试类型</a-button>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <standard-form-row grid>
            <div class="ant-pro-page-header-search">
              <a-input-search
                size="large"
                style="width: 80%; max-width: 522px;"
                v-model="params.where.name"
                placeholder="请输入名称"
                enter-button
                allow-clear
                @search="getLists()"
              />
            </div>
          </standard-form-row>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false" title="考试类型列表" class="screenfull">
      <div slot="extra">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        :scroll="scroll"
        @change="handleTableChange"
      >
        <template slot="state" slot-scope="text, record">
          <a-switch
            default-checked
            v-action:state
            :checked="record.need_code === 1"
            @change="handleChangeState(record.id)"
          >
            <a-icon slot="checkedChildren" type="check" />
            <a-icon slot="unCheckedChildren" type="close" />
          </a-switch>
        </template>
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-action:update>
              <a @click="() => handleEditModal(record.id)"><a-icon type="edit" /> 编辑</a>
            </span>
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="list.length"
              title="确定要删除吗？"
              @confirm="() => handleOnDelete(record.id)"
              v-action:delete
            >
              <a href="javascript:;"><a-icon type="delete" /> 删除</a>
            </a-popconfirm>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { TableToolBarList, StandardFormRow } from '@/components'
import { list, table } from '@/mixins/' // 引入
import form from './modules/form'

const apiList = {
    getList: '/certificates/modes',
    changeState: '/certificates/modes/',
    delete: '/certificates/modes/'
}

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        defaultSortOrder: 'descend',
        sorter: true
    },
    {
        title: '分类名称',
        dataIndex: 'name',
        scopedSlots: { customRender: 'name' }
    },
    {
        title: '链接',
        dataIndex: 'link',
        scopedSlots: { customRender: 'link' }
    },
    {
        title: '额外参数',
        dataIndex: 'extra',
        scopedSlots: { customRender: 'extra' }
    },
    {
        title: '是否分配考试码',
        dataIndex: 'state',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '排序',
        dataIndex: 'sort',
        sorter: true,
        scopedSlots: { customRender: 'sort' }
    },
    {
        title: '末次更新',
        sorter: true,
        dataIndex: 'updated_at'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: '150px',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'CertificateMode',
    mixins: [list, table],
    components: {
        TableToolBarList,
        StandardFormRow
    },
    data () {
        return {
            scroll: { x: 1200 },
            apiList,
            form: this.$form.createForm(this), // 添加数据
            element: '.screenfull', // 全屏dom
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {
        /**
         * 点击批量导入弹窗口
         * @jdy
         * @2021-4-16
         */
        handleAddModal () {
            const that = this
            that.$dialog(
                form,
                {
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '考试类型',
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭'
                }
            )
        },
        /**
         * 点击批量导入弹窗口
         * @jdy
         * @2021-4-16
         */
        handleEditModal (id) {
            const that = this
            that.$dialog(
                form,
                {
                    id,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '考试类型',
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭'
                }
            )
        }
    }
}
</script>
